class ApiExportRequestDto {
  /** 接口编码列表 */
  apiCodes = [];

  /** 应用编码 */
  appCode = "";
}

class ApiHeaderDto {
  /** 接口编号 */
  apiCode = "";

  /** 是否校验 */
  checkFlag = false;

  /** 接口header编号 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 名称 */
  headerName = "";

  /** id */
  id = undefined;

  /** 类型 */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ApiImportRequestDto {
  /** 接口信息聚合列表 */
  apiInfoAggregates = [];

  /** 应用编码 */
  appCode = "";
}

class ApiInfoAggregateDto {
  /** 编号 */
  apiCode = "";

  /** 接口请求头列表 */
  apiHeaders = [];

  /** 名称 */
  apiName = "";

  /** 接口请求参数列表 */
  apiParameters = [];

  /** 接口出参 */
  apiResponse = new ApiResponseTreeDto();

  /** 应用编码 */
  appCode = "";

  /** 子节点列表 */
  children = [];

  /** 接口出参编号 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 描述 */
  description = "";

  /** 字段名称 */
  fieldName = "";

  /** id */
  id = undefined;

  /** 请求方式 */
  method = "";

  /** 模块 */
  module = "";

  /** 父级参数code: 接口:root */
  parentCode = "";

  /** 接收类型 */
  requestType = "";

  /** 返回类型 */
  responseType = "";

  /** 类型: int boolean string array object等 */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** URL */
  url = "";
}

class ApiInfoResponseDto {
  /** 编号 */
  apiCode = "";

  /** 名称 */
  apiName = "";

  /** 应用编码 */
  appCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 请求方式 */
  method = "";

  /** 模块 */
  module = "";

  /** 接收类型 */
  requestType = "";

  /** 返回类型 */
  responseType = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** URL */
  url = "";
}

class ApiParameterTreeDto {
  /** 接口编号 */
  apiCode = "";

  /** 是否校验 */
  checkFlag = false;

  /** 子节点列表 */
  children = [];

  /** 接口参数编号 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 描述 */
  description = "";

  /** 字段名称 */
  fieldName = "";

  /** id */
  id = undefined;

  /** 参数方式：query/body */
  paramMode = "";

  /** 父级参数code: 接口:root */
  parentCode = "";

  /** 类型: int boolean string array object等 */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ApiResponseResponseDto {
  /** 接口编号 */
  apiCode = "";

  /** 接口出参编号 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 描述 */
  description = "";

  /** 字段名称 */
  fieldName = "";

  /** id */
  id = undefined;

  /** 父级参数code: 接口:root */
  parentCode = "";

  /** 类型: int boolean string array object等 */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ApiResponseTreeDto {
  /** 接口编号 */
  apiCode = "";

  /** 子节点列表 */
  children = [];

  /** 接口出参编号 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 描述 */
  description = "";

  /** 字段名称 */
  fieldName = "";

  /** id */
  id = undefined;

  /** 父级参数code: 接口:root */
  parentCode = "";

  /** 类型: int boolean string array object等 */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ApiScopeAggregateResponseDto {
  /** 应用域编码 */
  appDomainCode = "";

  /** 应用接口关系信息 */
  apps = [];

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 作用域编码 */
  scopeCode = "";

  /** 作用域KEY */
  scopeKey = "";

  /** 作用域名称 */
  scopeName = "";

  /** 作用域类型 api 接口 */
  scopeType = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ApiScopeBindRequestDto {
  /** 接口编码列表 */
  apiCodes = [];

  /** 接口作用域编码 */
  apiScopeCode = "";
}

class ApiScopeRequestDto {
  /** 应用域编码 */
  appDomainCode = "";

  /** id */
  id = undefined;

  /** 作用域编码 */
  scopeCode = "";

  /** 作用域KEY */
  scopeKey = "";

  /** 作用域名称 */
  scopeName = "";
}

class AppApiRelationResponseDto {
  /** 接口编码 */
  apiCodes = [];

  /** 应用编码 */
  appCode = "";

  /** 作用域编码 */
  scopeCode = "";
}

class AppAuthRequestDto {
  /** 令牌 */
  accessToken = "";

  /** 应用编码 */
  appCode = "";

  /** appId */
  appId = "";

  /** appSecret */
  appSecret = "";

  /** 令牌有效时间 */
  atEffectiveTime = undefined;

  /** 授权类型 */
  grantType = "";

  /** id */
  id = undefined;

  /** 最新刷新令牌时间 */
  lastAuthTime = "";

  /** 最新授权令牌时间 */
  lastRefreshTime = "";

  /** 重定向URL */
  redirectUrl = "";

  /** 刷新令牌 */
  refreshToken = "";

  /** 刷新令牌有效时间 */
  rtEffectiveTime = undefined;
}

class AppAuthResponseDto {
  /** 令牌 */
  accessToken = "";

  /** 应用编码 */
  appCode = "";

  /** appId */
  appId = "";

  /** appSecret */
  appSecret = "";

  /** 令牌有效时间 */
  atEffectiveTime = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 授权类型 */
  grantType = "";

  /** id */
  id = undefined;

  /** 最新刷新令牌时间 */
  lastAuthTime = "";

  /** 最新授权令牌时间 */
  lastRefreshTime = "";

  /** 重定向URL */
  redirectUrl = "";

  /** 刷新令牌 */
  refreshToken = "";

  /** 刷新令牌有效时间 */
  rtEffectiveTime = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AppAuthScopeRelationBatchRequestDto {
  /** appId */
  appId = [];

  /** 接口作用域编码 */
  scopeCode = [];
}

class AppAuthScopeRelationResponseDto {
  /** appId */
  appId = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 接口作用域编码 */
  scopeCode = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AppDomainAggregateRequestDto {
  /** 关联应用列表 */
  appCodes = [];

  /** 编码 */
  code = "";

  /** 描述 */
  description = "";

  /** 是否启用 */
  enable = false;

  /** 图标 */
  icon = "";

  /** id */
  id = undefined;

  /** 名称 */
  name = "";

  /** 用户中心应用编码 */
  userCenterCode = "";
}

class AppDomainAggregateResponseDto {
  /** 关联应用列表 */
  appCodes = [];

  /** 编码 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 描述 */
  description = "";

  /** 是否启用 */
  enable = false;

  /** 图标 */
  icon = "";

  /** id */
  id = undefined;

  /** 名称 */
  name = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 用户中心应用编码 */
  userCenterCode = "";
}

class AppDomainMenuAggregateRequestDto {
  /** 应用域编码 */
  appDomainCode = "";

  /** 所属系统资源路径 */
  appEntry = "";

  /** 所属系统 */
  appName = "";

  /** 按钮信息 */
  buttons = [];

  /** 编码 */
  code = "";

  /** 描述 */
  description = "";

  /** 是否启用 */
  enable = false;

  /** 是否在导航栏显示 0否 1是 */
  hiddenFlag = false;

  /** id */
  id = undefined;

  /** 名称 */
  name = "";

  /** 父菜单编码 */
  parentCode = "";

  /** URL */
  resUrl = "";

  /** 路由别名 */
  routeAlias = "";

  /** 路由别名路径，包含当前菜单 */
  routeAliasPath = "";

  /** 排序 */
  sort = undefined;

  /** 类型：menu菜单 page页面 */
  type = "";
}

class AppDomainMenuAggregateResponseDto {
  /** 应用域编码 */
  appDomainCode = "";

  /** 所属系统资源路径 */
  appEntry = "";

  /** 所属系统 */
  appName = "";

  /** 按钮信息 */
  buttons = [];

  /** 编码 */
  code = "";

  /** 描述 */
  description = "";

  /** 是否启用 */
  enable = false;

  /** 是否在导航栏显示 0否 1是 */
  hiddenFlag = false;

  /** id */
  id = undefined;

  /** 名称 */
  name = "";

  /** 父菜单编码 */
  parentCode = "";

  /** URL */
  resUrl = "";

  /** 路由别名 */
  routeAlias = "";

  /** 路由别名路径，包含当前菜单 */
  routeAliasPath = "";

  /** 排序 */
  sort = undefined;

  /** 类型：menu菜单 page页面 */
  type = "";

  /** 视图信息 */
  views = [];
}

class AppDomainMenuResponseDto {
  /** 应用域编码 */
  appDomainCode = "";

  /** 所属系统资源路径 */
  appEntry = "";

  /** 所属系统 */
  appName = "";

  /** 编码 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 描述 */
  description = "";

  /** 是否启用 */
  enable = false;

  /** 是否在导航栏显示 0否 1是 */
  hiddenFlag = false;

  /** id */
  id = undefined;

  /** 名称 */
  name = "";

  /** 父菜单编码 */
  parentCode = "";

  /** URL */
  resUrl = "";

  /** 路由别名 */
  routeAlias = "";

  /** 排序 */
  sort = undefined;

  /** 类型：menu菜单 page页面 */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AppDomainMenuTreeResponseDto {
  /** 应用域编码 */
  appDomainCode = "";

  /** 所属系统资源路径 */
  appEntry = "";

  /** 所属系统 */
  appName = "";

  /** 子菜单 */
  children = [];

  /** 编码 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 描述 */
  description = "";

  /** 是否启用 */
  enable = false;

  /** 是否在导航栏显示 0否 1是 */
  hiddenFlag = false;

  /** id */
  id = undefined;

  /** 名称 */
  name = "";

  /** 父菜单编码 */
  parentCode = "";

  /** URL */
  resUrl = "";

  /** 路由别名 */
  routeAlias = "";

  /** 排序 */
  sort = undefined;

  /** 类型：menu菜单 page页面 */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AppDomainMenuTreeWithButtonResponseDto {
  /** 应用域编码 */
  appDomainCode = "";

  /** 所属系统资源路径 */
  appEntry = "";

  /** 所属系统 */
  appName = "";

  /** 按钮 */
  buttons = [];

  /** 子菜单 */
  children = [];

  /** 编码 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 描述 */
  description = "";

  /** 是否启用 */
  enable = false;

  /** 是否在导航栏显示 0否 1是 */
  hiddenFlag = false;

  /** id */
  id = undefined;

  /** 名称 */
  name = "";

  /** 父菜单编码 */
  parentCode = "";

  /** URL */
  resUrl = "";

  /** 路由别名 */
  routeAlias = "";

  /** 排序 */
  sort = undefined;

  /** 类型：menu菜单 page页面 */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AppDomainResponseDto {
  /** 编码 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 描述 */
  description = "";

  /** 是否启用 */
  enable = false;

  /** 图标 */
  icon = "";

  /** id */
  id = undefined;

  /** 名称 */
  name = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 用户中心应用编码 */
  userCenterCode = "";
}

class AppDomainRoleAggregateResponseDto {
  /** 应用域编码 */
  appDomainCode = "";

  /** 编码 */
  code = "";

  /** 菜单列表 */
  menus = [];

  /** 名称 */
  name = "";
}

class AppDomainRoleDimensionResponseDto {
  /** 应用域编码 */
  appDomainCode = "";

  /** 数据维度聚合列表 */
  dimensions = [];

  /** 角色编码 */
  roleCode = "";
}

class AppDomainRoleRequestDto {
  /** 应用域编码 */
  appDomainCode = "";

  /** 编码 */
  code = "";

  /** 描述 */
  description = "";

  /** id */
  id = undefined;

  /** 名称 */
  name = "";

  /** 角色类型：0=默认，1=个人 */
  roleType = undefined;
}

class AppDomainRoleResponseDto {
  /** 应用域编码 */
  appDomainCode = "";

  /** 编码 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 描述 */
  description = "";

  /** id */
  id = undefined;

  /** 名称 */
  name = "";

  /** 角色类型：0=默认，1=个人 */
  roleType = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AppDomainRoleRpcRequestDto {
  /** 应用域编码 */
  appDomainCode = "";

  /** 编码 */
  code = "";

  /** 描述 */
  description = "";

  /** 名称 */
  name = "";

  /** 角色类型：0=默认，1=个人 */
  roleType = undefined;
}

class AppDomainRoleUserResponseDto {
  /** 角色列表 */
  roles = [];

  /** 用户编码 */
  userCode = "";
}

class AppDomainScopeResponseDto {
  /** 应用域编码 */
  appDomainCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 作用域编码 */
  scopeCode = "";

  /** 作用域KEY */
  scopeKey = "";

  /** 作用域名称 */
  scopeName = "";

  /** 作用域类型：button 按钮 api 接口 */
  scopeType = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AppExtendRequestDto {
  /** 应用集群地址 */
  appClusterUrls = "";

  /** 应用编码 */
  appCode = "";

  /** 应用状态 */
  appStatus = "";

  /** id */
  id = undefined;

  /** 服务名，rpc调用需要 */
  serviceName = "";

  /** Swagger地址 */
  swaggerUrl = "";

  /** 是否同步Swagger */
  syncSwaggerFlag = false;
}

class AppExtendResponseDto {
  /** 应用集群地址 */
  appClusterUrls = "";

  /** 应用编码 */
  appCode = "";

  /** 应用状态 */
  appStatus = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 服务名，rpc调用需要 */
  serviceName = "";

  /** Swagger地址 */
  swaggerUrl = "";

  /** 是否同步Swagger */
  syncSwaggerFlag = false;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AppRoleResponseDto {
  /** 编码 */
  code = "";

  /** 名称 */
  name = "";
}

class ApplicationAggregateResponseDto {
  /** 应用编码 */
  appCode = "";

  /** 应用描述 */
  appDesc = "";

  /** 应用拓展信息 */
  appExtendResponseDto = new AppExtendResponseDto();

  /** 应用名称 */
  appName = "";

  /** 应用类型 */
  appType = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 是否启用 */
  enable = false;

  /** id */
  id = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ApplicationRequestDto {
  /** 应用编码 */
  appCode = "";

  /** 应用描述 */
  appDesc = "";

  /** 应用拓展信息 */
  appExtendRequestDto = new AppExtendRequestDto();

  /** 应用名称 */
  appName = "";

  /** 应用类型 */
  appType = "";

  /** 是否启用，默认启用 */
  enable = false;

  /** id */
  id = undefined;
}

class ApplicationResponseDto {
  /** 应用编码 */
  appCode = "";

  /** 应用描述 */
  appDesc = "";

  /** 应用名称 */
  appName = "";

  /** 应用类型 */
  appType = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 是否启用 */
  enable = false;

  /** id */
  id = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BizPermissionApplyRequestDto {
  /** 应用域编码,前端默认 erp */
  appDomainCode = "";

  /** 申请人部门 */
  applicantDept = "";

  /** 业务权限申请角色 */
  bizPermissionApplyRole = new BizPermissionApplyRolesRequestDto();

  /** 备注 */
  remark = "";
}

class BizPermissionApplyResponseDto {
  /** 申请人 */
  applicant = "";

  /** 申请人部门 */
  applicantDept = "";

  /** 审批状态,-1：待提交、0:审批驳回 1:审批通过 2：审批中 */
  approvalStatus = undefined;

  /** 菜单明细 */
  bizPermissionApplyRoles = new BizPermissionApplyRolesResponseDto();

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 主键ID */
  id = undefined;

  /** 流程实例ID */
  instanceId = "";

  /** 版本号 */
  lockVersion = undefined;

  /** 权限申请单号 */
  paNo = "";

  /** 备注 */
  remark = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BizPermissionApplyRolesRequestDto {
  /** 申请菜单快照 */
  menuSnapshot = new PermissionConfigureRequestDto();

  /** 角色编码 */
  roleCode = "";

  /** 涉及的所有二级菜单编码 */
  secondaryMenuCodes = [];
}

class BizPermissionApplyRolesResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 主键ID */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 申请菜单快照 */
  menuSnapshot = "";

  /** 权限申请单号 */
  paNo = "";

  /** 角色编码 */
  roleCode = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BizSecondaryAdminConfigRequestDto {
  /** 应用编码 */
  appCode = "";

  /** 所属系统 */
  appName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 菜单/页面编码 */
  menuCode = "";

  /** 父菜单编码 */
  parentMenuCode = "";

  /** 二级管理员角色编码 */
  secondaryAdminRole = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BizSecondaryAdminConfigResponseDto {
  /** 应用编码 */
  appCode = "";

  /** 所属系统 */
  appName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 菜单/页面编码 */
  menuCode = "";

  /** 菜单/页面名称 */
  menuName = "";

  /** 父菜单编码 */
  parentMenuCode = "";

  /** 父菜单名称 */
  parentMenuName = "";

  /** 二级管理员角色编码 */
  secondaryAdminRole = "";

  /** 二级管理员角色名称 */
  secondaryAdminRoleName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BpmRoleResponseDto {
  /** appId */
  appId = "";

  /** 应用域编码 */
  roles = [];
}

class ButtonAggregateRequestDto {
  /** 接口作用域编码列表 */
  apiScopeCodes = [];

  /** 应用域编码 */
  appDomainCode = "";

  /** id */
  id = undefined;

  /** 按钮作用域编码 */
  scopeCode = "";

  /** 作用域KEY */
  scopeKey = "";

  /** 作用域名称 */
  scopeName = "";
}

class ButtonAggregateResponseDto {
  /** 接口作用域编号列表 */
  apiScopeCodes = [];

  /** 应用域编码 */
  appDomainCode = "";

  /** id */
  id = undefined;

  /** 按钮作用域编码 */
  scopeCode = "";

  /** 作用域KEY */
  scopeKey = "";

  /** 作用域名称 */
  scopeName = "";
}

class Client {
  /** clientId */
  clientId = "";
}

class ClientDto {
  /** accessTokenValiditySeconds */
  accessTokenValiditySeconds = undefined;

  /** clientCode */
  clientCode = "";

  /** clientSecret */
  clientSecret = "";

  /** grantType */
  grantType = "";

  /** id */
  id = undefined;

  /** redirectUri */
  redirectUri = "";

  /** refreshTokenValiditySeconds */
  refreshTokenValiditySeconds = undefined;

  /** resUrls */
  resUrls = [];

  /** scope */
  scope = [];
}

class Code {
  /** code */
  code = "";
}

class DataDimensionAddRequestDto {
  /** 应用域编码 */
  appDomainCode = "";

  /** 名称 */
  ddName = "";

  /** 是否启用 true：启用，false：禁用 */
  enable = false;

  /** 数据来源类型：customize:自定义 api_sync:接口同步 */
  sourceType = "";

  /** 类型： enums:枚举 fixed:固定值 list:集合 el:表达式 */
  type = "";
}

class DataDimensionApiSyncRequestDto {
  /** 别名接口出参编码 */
  aliasApiResponseCode = "";

  /** 字段别名取值表达式 */
  aliasExpression = "";

  /** 别名接口出参字段名 */
  aliasFieldName = "";

  /** 接口编号 */
  apiCode = "";

  /** Header信息 */
  apiHeader = "";

  /** 请求方式 */
  apiMethod = "";

  /** 请求参数 */
  apiParameter = "";

  /** 接口URL */
  apiUrl = "";

  /** 数据维度编号 */
  ddCode = "";

  /** 同步规则表达式 */
  syncExpression = undefined;

  /** 值接口出参编码 */
  valueApiResponseCode = "";

  /** 字段取值表达式 */
  valueExpression = "";

  /** 值接口出参字段名 */
  valueFieldName = "";
}

class DataDimensionApiSyncResponseDto {
  /** 别名接口出参编码 */
  aliasApiResponseCode = "";

  /** 字段别名取值表达式 */
  aliasExpression = "";

  /** 别名接口出参字段名 */
  aliasFieldName = "";

  /** 接口编号 */
  apiCode = "";

  /** Header信息 */
  apiHeader = "";

  /** 请求方式 */
  apiMethod = "";

  /** 请求参数 */
  apiParameter = "";

  /** 接口URL */
  apiUrl = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 数据维度编号 */
  ddCode = "";

  /** id */
  id = undefined;

  /** 同步规则表达式 */
  syncExpression = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 值接口出参编码 */
  valueApiResponseCode = "";

  /** 字段取值表达式 */
  valueExpression = "";

  /** 值接口出参字段名 */
  valueFieldName = "";
}

class DataDimensionResponseDto {
  /** 应用域编码 */
  appDomainCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 编号 */
  ddCode = "";

  /** 名称 */
  ddName = "";

  /** 是否启用 true：启用，false：禁用 */
  enable = false;

  /** id */
  id = undefined;

  /** 数据来源类型：customize:自定义 api_sync:接口同步 */
  sourceType = "";

  /** 类型： enums:枚举 fixed:固定值 list:集合 el:表达式 */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class DataDimensionSourceValueAddBatchRequestDto {
  /** 数据维度编号 */
  data = [];
}

class DataDimensionSourceValueAddRequestDto {
  /** 源数据别名 */
  aliasName = "";

  /** 数据维度编号 */
  ddCode = "";

  /** 是否显示 1：显示，0：不显示 */
  showFlag = false;

  /** 源数据值 */
  sourceValue = "";
}

class DataDimensionSourceValueDto {
  /** aliasName */
  aliasName = "";

  /** ddCode */
  ddCode = "";

  /** sourceCode */
  sourceCode = "";

  /** sourceValue */
  sourceValue = "";
}

class DataDimensionSourceValueModifyRequestDto {
  /** 源数据别名 */
  aliasName = "";

  /** 数据维度编号 */
  ddCode = "";

  /** 是否显示 1：显示，0：不显示 */
  showFlag = false;

  /** 源数据编号 */
  sourceCode = "";

  /** 源数据值 */
  sourceValue = "";
}

class DataDimensionSourceValueResponseDto {
  /** 源数据别名 */
  aliasName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 数据维度编号 */
  ddCode = "";

  /** id */
  id = undefined;

  /** 是否显示 1：显示，0：不显示 */
  showFlag = false;

  /** 源数据编号 */
  sourceCode = "";

  /** 源数据值 */
  sourceValue = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class DataPermissionAuthenticateParameterDto {
  /** basicType */
  basicType = false;

  /** index */
  index = undefined;

  /** name */
  name = "";

  /** stringType */
  stringType = false;

  /** value */
  value = undefined;
}

class DataPermissionAuthenticateRequestDto {
  /** 菜单编码 */
  menuCode = "";

  /** 请求方法 */
  method = "";

  /** 请求参数 */
  parameters = [];

  /** 需要校验的服务名（客户端服务名） */
  serviceName = "";

  /** 请求的url */
  url = "";

  /** 用户编码 */
  userCode = "";
}

class DataPermissionAuthenticateResponseDto {
  /** 认证结果 */
  checkResult = false;

  /** 权限信息（请求时不填充，返回时填充） */
  dataPermission = new PageViewAggregationResponseDto();

  /** 错误信息 */
  errorMsg = "";

  /** 菜单编码 */
  menuCode = "";

  /** 请求方法 */
  method = "";

  /** 请求参数 */
  parameters = [];

  /** 是否配置数据权限 */
  permissionResult = false;

  /** 需要校验的服务名（客户端服务名） */
  serviceName = "";

  /** 请求的url */
  url = "";

  /** 用户编码 */
  userCode = "";
}

class DataPermissionCacheRequestDto {
  /** 认证结果 */
  checkResult = false;

  /** 权限信息（请求时不填充，返回时填充） */
  dataPermission = new PageViewAggregationResponseDto();

  /** 请求方法 */
  method = "";

  /** 请求参数 */
  parameters = [];

  /** 查询结果 */
  response = "";

  /** 需要校验的服务名（客户端服务名） */
  serviceName = "";

  /** 请求的url */
  url = "";

  /** 用户编码 */
  userCode = "";
}

class DataPermissionCacheResponseDto {
  /** 查询结果 */
  cacheResult = false;

  /** 认证结果 */
  checkResult = false;

  /** 权限信息（请求时不填充，返回时填充） */
  dataPermission = new PageViewAggregationResponseDto();

  /** 请求方法 */
  method = "";

  /** 请求参数 */
  parameters = [];

  /** 查询结果 */
  response = undefined;

  /** 需要校验的服务名（客户端服务名） */
  serviceName = "";

  /** 请求的url */
  url = "";

  /** 用户编码 */
  userCode = "";
}

class DimensionAggregateResponseDto {
  /** 全选标识 */
  allFlag = false;

  /** 应用域编码 */
  appDomainCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 编号 */
  ddCode = "";

  /** 名称 */
  ddName = "";

  /** 是否启用 true：启用，false：禁用 */
  enable = false;

  /** 数据来源类型：customize:自定义 api_sync:接口同步 */
  sourceType = "";

  /** 数据维度源数据列表 */
  sourceValues = [];

  /** 全选的数据维度源数据列表 */
  sourceValuesWithAllFlag = [];

  /** 类型： enums:枚举 fixed:固定值 list:集合 el:表达式 */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class DimensionConfigureRequestDto {
  /** 全选维度编码列表 */
  allFlagDdCodes = [];

  /** 维度编码列表 */
  ddCodes = [];

  /** 角色编码 */
  roleCode = "";

  /** 数据编码列表 */
  sourceCodes = [];
}

class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class LoginExchangeDto {
  /** accessToken */
  accessToken = "";

  /** clientCode */
  clientCode = "";

  /** expiresIn */
  expiresIn = undefined;

  /** jobNo */
  jobNo = "";

  /** openId */
  openId = "";

  /** refreshToken */
  refreshToken = "";

  /** scope */
  scope = [];

  /** userCode */
  userCode = "";

  /** userId */
  userId = undefined;

  /** userName */
  userName = "";
}

class PageViewAggregationResponseDto {
  /** 详情查询字段，多个字段需要使用;;两个英文分号隔开 */
  infoInField = "";

  /** 详情查询接口字段编号 */
  infoInFieldApiParameterCode = "";

  /** 详情查询字段表达式 */
  infoInFieldExpression = "";

  /** 视图主接口编码 */
  mainApiCode = "";

  /** 视图主接口信息 */
  mainApiInfo = new ApiInfoResponseDto();

  /** 页面编码 */
  pageCode = "";

  /** 分页出参字段，多个字段需要使用;;两个英文分号隔开 */
  pageOutField = "";

  /** 分页出参字段接口返回值编号 */
  pageOutFieldApiResponseCode = "";

  /** 分页出参字段表达式 */
  pageOutFieldExpression = "";

  /** 查询字段列表 */
  queries = [];

  /** 角色编码 */
  roleCode = "";

  /** 角色菜单-视图关联编码 */
  roleMenuViewCode = "";

  /** 表格列表 */
  tables = [];

  /** 类型 page：页面，info：详情，edit：编辑 */
  type = "";

  /** 视图编码 */
  viewCode = "";

  /** 视图名称 */
  viewName = "";

  /** 视图URL */
  viewUrl = "";
}

class PageViewBindRequestDto {
  /** 视图主接口编码 */
  mainApiCode = "";

  /** 视图编码 */
  viewCode = "";
}

class PageViewModifyRequestDto {
  /** 是否启用 true：启用，false：禁用 */
  enable = false;

  /** 详情查询字段，多个字段需要使用;;两个英文分号隔开 */
  infoInField = "";

  /** 详情查询接口字段编号，多个字段需要使用;;两个英文分号隔开 */
  infoInFieldApiParameterCode = "";

  /** 详情查询字段表达式 */
  infoInFieldExpression = "";

  /** 视图主接口编码 */
  mainApiCode = "";

  /** 分页出参字段，多个字段需要使用;;两个英文分号隔开 */
  pageOutField = "";

  /** 分页出参字段接口返回值编号，多个字段需要使用;;两个英文分号隔开 */
  pageOutFieldApiResponseCode = "";

  /** 分页出参字段表达式 */
  pageOutFieldExpression = "";

  /** 视图编码 */
  viewCode = "";

  /** 视图名称 */
  viewName = "";

  /** 视图URL */
  viewUrl = "";
}

class PageViewRequestDto {
  /** 是否启用 true：启用，false：禁用 */
  enable = false;

  /** 详情查询字段，多个字段需要使用;;两个英文分号隔开 */
  infoInField = "";

  /** 详情查询接口字段编号 */
  infoInFieldApiParameterCode = "";

  /** 详情查询字段表达式 */
  infoInFieldExpression = "";

  /** 视图主接口编码 */
  mainApiCode = "";

  /** 页面编码 */
  pageCode = "";

  /** 分页出参字段，多个字段需要使用;;两个英文分号隔开 */
  pageOutField = "";

  /** 分页出参字段接口返回值编号 */
  pageOutFieldApiResponseCode = "";

  /** 分页出参字段表达式 */
  pageOutFieldExpression = "";

  /** 类型 page：页面，info：详情，edit：编辑 */
  type = "";

  /** 视图名称 */
  viewName = "";

  /** 视图URL */
  viewUrl = "";
}

class PageViewResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 是否启用 true：启用，false：禁用 */
  enable = false;

  /** id */
  id = undefined;

  /** 详情查询字段，多个字段需要使用;;两个英文分号隔开 */
  infoInField = "";

  /** 详情查询接口字段编号 */
  infoInFieldApiParameterCode = "";

  /** 详情查询字段表达式 */
  infoInFieldExpression = "";

  /** 视图主接口编码 */
  mainApiCode = "";

  /** 页面编码 */
  pageCode = "";

  /** 分页出参字段，多个字段需要使用;;两个英文分号隔开 */
  pageOutField = "";

  /** 分页出参字段接口返回值编号 */
  pageOutFieldApiResponseCode = "";

  /** 分页出参字段表达式 */
  pageOutFieldExpression = "";

  /** 类型 page：页面，info：详情，edit：编辑 */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 视图编码 */
  viewCode = "";

  /** 视图名称 */
  viewName = "";

  /** 视图URL */
  viewUrl = "";
}

class PermissionConfigureRequestDto {
  /** 按钮编码列表 */
  buttonCodes = [];

  /** 菜单编码列表 */
  menuCodes = [];

  /** 角色编码 */
  roleCode = "";

  /** 视图配置列表 */
  viewConfigs = [];
}

class QueryAggregateResponseDto {
  /** 字段编码 */
  fieldCode = "";

  /** 是否跟随角色维度配置 */
  followRoleDataDimensionFlag = false;

  /** 角色菜单视图查询字段编码 */
  roleMenuViewQueryCode = "";

  /** 源数据编号 */
  sourceCodes = [];

  /** 视图编码 */
  viewCode = "";
}

class ResourceAuthorizedResponseDto {
  /** 角色 */
  roles = [];

  /** 用户编码列表 */
  userCodes = [];
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new ApiInfoAggregateDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class RoleUserRelationResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 角色编码 */
  roleCode = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 用户编号 */
  userNo = "";
}

class RoleUserRemoveRequestDto {
  /** 角色编码列表 */
  roleCodes = [];

  /** 用户编码 */
  userCodes = [];
}

class RoleViewResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 是否启用 true：启用，false：禁用 */
  enable = false;

  /** id */
  id = undefined;

  /** 详情查询字段，多个字段需要使用;;两个英文分号隔开 */
  infoInField = "";

  /** 视图主接口编码 */
  mainApiCode = "";

  /** 页面编码 */
  pageCode = "";

  /** 分页出参字段，多个字段需要使用;;两个英文分号隔开 */
  pageOutField = "";

  /** 角色编码 */
  roleCode = "";

  /** 角色菜单-视图编码 */
  roleMenuViewCode = "";

  /** 类型 page：页面，info：详情，edit：编辑 */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 视图编码 */
  viewCode = "";

  /** 视图名称 */
  viewName = "";

  /** 视图URL */
  viewUrl = "";
}

class TableAggregateResponseDto {
  /** 列字段编码列表列表 */
  columnCodes = [];

  /** 角色视图表格编码 */
  roleMenuViewTableCode = "";

  /** 表格编码 */
  tableCode = "";

  /** 视图编码 */
  viewCode = "";
}

class TableColumnAddRequestDto {
  /** 列字段接口表达式 */
  columnApiExpression = "";

  /** 列字段接口返回值编号 */
  columnApiResponseCode = "";

  /** 列字段key */
  columnKey = "";

  /** 列字段名称 */
  columnName = "";

  /** 是否启用 true：启用，false：禁用 */
  enable = false;

  /** 表格编码 */
  tableCode = "";
}

class TableColumnBatchAddRequestDto {
  /** 表格编码 */
  tableCode = "";

  /** 列字段添加请求列表 */
  tableColumnAddRequests = [];
}

class TableColumnInfoResponseDto {
  /** 列字段接口表达式 */
  columnApiExpression = "";

  /** 列字段接口返回值编号 */
  columnApiResponseCode = "";

  /** 列字段编码 */
  columnCode = "";

  /** 列字段key */
  columnKey = "";

  /** 列字段名称 */
  columnName = "";

  /** 表格编码 */
  tableCode = "";
}

class TableColumnResponseDto {
  /** 列字段接口表达式 */
  columnApiExpression = "";

  /** 列字段接口返回值编号 */
  columnApiResponseCode = "";

  /** 列字段编码 */
  columnCode = "";

  /** 列字段key */
  columnKey = "";

  /** 列字段名称 */
  columnName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 是否启用 true：启用，false：禁用 */
  enable = false;

  /** id */
  id = undefined;

  /** 表格编码 */
  tableCode = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class UserDto {
  /** clientCode */
  clientCode = "";

  /** clientList */
  clientList = [];

  /** clientType */
  clientType = "ADMIN";

  /** jobNo */
  jobNo = "";

  /** jti */
  jti = "";

  /** password */
  password = "";

  /** scope */
  scope = [];

  /** userCode */
  userCode = "";

  /** userId */
  userId = undefined;

  /** userName */
  userName = "";
}

class UserPermissionConfigureRequestDto {
  /** 角色编码列表 */
  roleCodes = [];

  /** 用户编码 */
  userCodes = [];
}

class UserResourceDto {
  /** accessToken */
  accessToken = "";

  /** accessTokenValiditySeconds */
  accessTokenValiditySeconds = undefined;

  /** appResources */
  appResources = [];

  /** clientCode */
  clientCode = "";

  /** clientType */
  clientType = "ADMIN";

  /** expiresIn */
  expiresIn = undefined;

  /** jobNo */
  jobNo = "";

  /** jti */
  jti = "";

  /** refreshTokenValiditySeconds */
  refreshTokenValiditySeconds = undefined;

  /** userCode */
  userCode = "";

  /** userName */
  userName = "";

  /** userResources */
  userResources = [];
}

class UserResponseDto {
  /** 应用域 */
  applicationDomain = "";

  /** 手机区号 */
  areaCode = "";

  /** 头像链接 */
  avatar = "";

  /** 生日 */
  birthday = "";

  /** 国家 */
  country = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 用户邮箱 */
  email = "";

  /** 用户名字 */
  firstname = "";

  /** 用户姓氏 */
  lastname = "";

  /** 用户手机号码 */
  phone = "";

  /** 状态，0：禁用，1：启用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 用户编号 */
  userNo = "";

  /** 账号名 */
  username = "";
}

class ViewAggregateResponseDto {
  /** 页面编码 */
  pageCode = "";

  /** 查询字段列表 */
  queries = [];

  /** 角色菜单-视图关联编码 */
  roleMenuViewCode = "";

  /** 表格列表 */
  tables = [];

  /** 视图编码 */
  viewCode = "";

  /** 视图名称 */
  viewName = "";
}

class ViewConfigureRefreshRequestDto {
  /** 角色编码列表 */
  roleCodes = [];
}

class ViewConfigureRequestDto {
  /** id */
  id = undefined;

  /** 视图查询字段列表 */
  queries = [];

  /** 角色菜单-视图编码 */
  roleMenuViewCode = "";

  /** 视图表格列表 */
  tables = [];

  /** 视图编码 */
  viewCode = "";
}

class ViewQueryConfigureRequestDto {
  /** 字段编码 */
  fieldCode = "";

  /** 是否跟随角色维度配置 */
  followRoleDataDimensionFlag = false;

  /** 角色菜单视图查询字段编码 */
  roleMenuViewQueryCode = "";

  /** 源数据编号 */
  sourceCodes = [];
}

class ViewQueryFieldAddRequestDto {
  /** 数据维度编号 */
  ddCode = "";

  /** 字段接口请求参数 */
  fieldApiParameterCode = "";

  /** 字段编码 */
  fieldCode = "";

  /** 字段表达式 */
  fieldExpression = "";

  /** 字段KEY(前端) */
  fieldKey = "";

  /** 字段名称 */
  fieldName = "";

  /** 字段KEY(后端) */
  fieldObjKey = "";

  /** 输入类型：input:输入框 single:单选  check:多选 date:时间选择器 expression:表达式 */
  fieldType = "";

  /** 前端组件参数，json字符串 */
  props = "";

  /** 视图编码 */
  viewCode = "";
}

class ViewQueryFieldAggregationResponseDto {
  /** 全选标识 */
  allFlag = false;

  /** 勾选标识 */
  checkFlag = false;

  /** 数据维度编号 */
  ddCode = "";

  /** 数据维度类型： enums:枚举 fixed:固定值 list:集合 el:表达式 */
  ddType = "";

  /** 字段编码 */
  fieldCode = "";

  /** 字段KEY(前端) */
  fieldKey = "";

  /** 字段名称 */
  fieldName = "";

  /** 字段KEY(后端) */
  fieldObjKey = "";

  /** 输入类型：input:输入框 single:单选  check:多选 date:时间选择器 expression:表达式 */
  fieldType = "";

  /** 是否跟随角色维度配置 */
  followRoleDataDimensionFlag = false;

  /** 前端组件参数，json字符串 */
  props = "";

  /** 角色编码 */
  roleCode = "";

  /** 角色菜单视图查询字段编码 */
  roleMenuViewQueryCode = "";

  /** 维度数据源数据 */
  values = [];

  /** 视图编码 */
  viewCode = "";
}

class ViewQueryFieldModifyRequestDto {
  /** 数据维度编号 */
  ddCode = "";

  /** 字段接口请求参数 */
  fieldApiParameterCode = "";

  /** 字段编码 */
  fieldCode = "";

  /** 字段表达式 */
  fieldExpression = "";

  /** 字段KEY(前端) */
  fieldKey = "";

  /** 字段名称 */
  fieldName = "";

  /** 字段KEY(后端) */
  fieldObjKey = "";

  /** fieldType */
  fieldType = "";

  /** 前端组件参数，json字符串 */
  props = "";
}

class ViewQueryFieldResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 数据维度编号 */
  ddCode = "";

  /** 字段接口请求参数 */
  fieldApiParameterCode = "";

  /** 字段编码 */
  fieldCode = "";

  /** 字段表达式 */
  fieldExpression = "";

  /** 字段KEY(前端) */
  fieldKey = "";

  /** 字段名称 */
  fieldName = "";

  /** 字段KEY(后端) */
  fieldObjKey = "";

  /** 输入类型：input:输入框 single:单选  check:多选 date:时间选择器 expression:表达式 */
  fieldType = "";

  /** id */
  id = undefined;

  /** 前端组件参数，json字符串 */
  props = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 视图编码 */
  viewCode = "";
}

class ViewQueryFieldSaveRequestDto {
  /** 字段编码 */
  fields = [];

  /** 视图编码 */
  viewCode = "";
}

class ViewRefreshRequestDto {
  /** 视图编码列表 */
  viewCodes = [];
}

class ViewTableBindRequestDto {
  /** 表格接口ID */
  apiCode = "";

  /** 列字段提取表达式 */
  columnExpressions = "";

  /** 表格编码 */
  tableCode = "";
}

class ViewTableConfigureRequestDto {
  /** 列字段编码列表列表 */
  columnCodes = [];

  /** 角色视图表格编码 */
  roleMenuViewTableCode = "";

  /** 表格编码 */
  tableCode = "";
}

class ViewTableInfoResponseDto {
  /** 表格接口ID */
  apiCode = "";

  /** 表格接口信息 */
  apiInfo = new ApiInfoResponseDto();

  /** 列字段提取表达式 */
  columnExpressions = "";

  /** 列字段列表 */
  columns = [];

  /** 是否主表格 */
  mainTableFlag = false;

  /** 角色菜单视图编码 */
  roleMenuViewCode = "";

  /** 角色视图表格编码 */
  roleMenuViewTableCode = "";

  /** 表格编码 */
  tableCode = "";

  /** 表格KEY */
  tableKey = "";

  /** 表格名称 */
  tableName = "";

  /** 表格类型 list：集合，object：对象 */
  tableType = "";

  /** 视图编码 */
  viewCode = "";
}

class ViewTableRequestDto {
  /** 表格接口ID */
  apiCode = "";

  /** 接口出参编码 */
  apiResponseCode = "";

  /** 列字段提取表达式 */
  columnExpressions = "";

  /** 是否启用 true：启用，false：禁用 */
  enable = false;

  /** 是否主表格 */
  mainTableFlag = false;

  /** 表格KEY */
  tableKey = "";

  /** 表格名称 */
  tableName = "";

  /** 表格类型 list：集合，object：对象 */
  tableType = "";

  /** 视图编码 */
  viewCode = "";
}

class ViewTableResponseDto {
  /** 表格接口ID */
  apiCode = "";

  /** 接口出参编码 */
  apiResponseCode = "";

  /** 列字段提取表达式 */
  columnExpressions = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 是否启用 true：启用，false：禁用 */
  enable = false;

  /** id */
  id = undefined;

  /** 是否主表格 */
  mainTableFlag = false;

  /** 表格编码 */
  tableCode = "";

  /** 表格KEY */
  tableKey = "";

  /** 表格名称 */
  tableName = "";

  /** 表格类型 list：集合，object：对象 */
  tableType = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 视图编码 */
  viewCode = "";
}

export const appCenter = {
  ApiExportRequestDto,
  ApiHeaderDto,
  ApiImportRequestDto,
  ApiInfoAggregateDto,
  ApiInfoResponseDto,
  ApiParameterTreeDto,
  ApiResponseResponseDto,
  ApiResponseTreeDto,
  ApiScopeAggregateResponseDto,
  ApiScopeBindRequestDto,
  ApiScopeRequestDto,
  AppApiRelationResponseDto,
  AppAuthRequestDto,
  AppAuthResponseDto,
  AppAuthScopeRelationBatchRequestDto,
  AppAuthScopeRelationResponseDto,
  AppDomainAggregateRequestDto,
  AppDomainAggregateResponseDto,
  AppDomainMenuAggregateRequestDto,
  AppDomainMenuAggregateResponseDto,
  AppDomainMenuResponseDto,
  AppDomainMenuTreeResponseDto,
  AppDomainMenuTreeWithButtonResponseDto,
  AppDomainResponseDto,
  AppDomainRoleAggregateResponseDto,
  AppDomainRoleDimensionResponseDto,
  AppDomainRoleRequestDto,
  AppDomainRoleResponseDto,
  AppDomainRoleRpcRequestDto,
  AppDomainRoleUserResponseDto,
  AppDomainScopeResponseDto,
  AppExtendRequestDto,
  AppExtendResponseDto,
  AppRoleResponseDto,
  ApplicationAggregateResponseDto,
  ApplicationRequestDto,
  ApplicationResponseDto,
  BizPermissionApplyRequestDto,
  BizPermissionApplyResponseDto,
  BizPermissionApplyRolesRequestDto,
  BizPermissionApplyRolesResponseDto,
  BizSecondaryAdminConfigRequestDto,
  BizSecondaryAdminConfigResponseDto,
  BpmRoleResponseDto,
  ButtonAggregateRequestDto,
  ButtonAggregateResponseDto,
  Client,
  ClientDto,
  Code,
  DataDimensionAddRequestDto,
  DataDimensionApiSyncRequestDto,
  DataDimensionApiSyncResponseDto,
  DataDimensionResponseDto,
  DataDimensionSourceValueAddBatchRequestDto,
  DataDimensionSourceValueAddRequestDto,
  DataDimensionSourceValueDto,
  DataDimensionSourceValueModifyRequestDto,
  DataDimensionSourceValueResponseDto,
  DataPermissionAuthenticateParameterDto,
  DataPermissionAuthenticateRequestDto,
  DataPermissionAuthenticateResponseDto,
  DataPermissionCacheRequestDto,
  DataPermissionCacheResponseDto,
  DimensionAggregateResponseDto,
  DimensionConfigureRequestDto,
  IPage,
  LoginExchangeDto,
  PageViewAggregationResponseDto,
  PageViewBindRequestDto,
  PageViewModifyRequestDto,
  PageViewRequestDto,
  PageViewResponseDto,
  PermissionConfigureRequestDto,
  QueryAggregateResponseDto,
  ResourceAuthorizedResponseDto,
  Response,
  ResponseDto,
  RoleUserRelationResponseDto,
  RoleUserRemoveRequestDto,
  RoleViewResponseDto,
  TableAggregateResponseDto,
  TableColumnAddRequestDto,
  TableColumnBatchAddRequestDto,
  TableColumnInfoResponseDto,
  TableColumnResponseDto,
  UserDto,
  UserPermissionConfigureRequestDto,
  UserResourceDto,
  UserResponseDto,
  ViewAggregateResponseDto,
  ViewConfigureRefreshRequestDto,
  ViewConfigureRequestDto,
  ViewQueryConfigureRequestDto,
  ViewQueryFieldAddRequestDto,
  ViewQueryFieldAggregationResponseDto,
  ViewQueryFieldModifyRequestDto,
  ViewQueryFieldResponseDto,
  ViewQueryFieldSaveRequestDto,
  ViewRefreshRequestDto,
  ViewTableBindRequestDto,
  ViewTableConfigureRequestDto,
  ViewTableInfoResponseDto,
  ViewTableRequestDto,
  ViewTableResponseDto,
};
